import { PricePeriodContextProvider } from '@features/TimberBuyer/SalesAgreements/PricePeriods/PricePeriodContext'
import { getSalesAgreementPricePeriodQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const PricePeriodLayout: React.FC = () => {
  const { timberBuyerId, salesAgreementId, pricePeriodId } = Route.useParams()
  const { data, isLoading, isError, refetch } = useQuery(
    getSalesAgreementPricePeriodQuery({ timberBuyerId, salesAgreementId, pricePeriodId }),
  )

  const handleRefetch = () => {
    void refetch()
  }

  return (
    <PricePeriodContextProvider value={{ data, isLoading, isError, refetch: handleRefetch }}>
      <Outlet />
    </PricePeriodContextProvider>
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId',
)({
  component: PricePeriodLayout,
})
